import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';

const planType = planTypes.ROOM_CONNECTOR;

export default {
  key: planTypes[planType],
  data() {
    return {
      planType,
      title: this.$t('billing.rc.title'),
      logo: getPlanLogo(planTypes.ROOM_CONNECTOR),
    };
  },
};
